module.exports = __webpack_public_path__ + "img/INSTALL_MV.3aa084a9.png";